"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapperFromColumnRefs = exports.makeOutputFunc = exports.timeShiftTransform = exports.timeShiftTransformCreator = exports.TimeShiftType = void 0;
var dateUtils_1 = require("../../dateUtils");
var comparisonEngine_1 = require("../../features/comparison/comparisonEngine");
var models_1 = require("../../models");
var Accessor_1 = require("../../models/Accessor");
exports.TimeShiftType = 'time-shift';
var isTimeShiftCalculation = function (calc) {
    return calc !== undefined && calc.type === exports.TimeShiftType;
};
var timeShiftTransformCreator = function (definition, name) {
    return function (sourceTable, windowedTable) { return (0, exports.timeShiftTransform)(definition, name, sourceTable, windowedTable); };
};
exports.timeShiftTransformCreator = timeShiftTransformCreator;
var timeShiftTransform = function (definition, name, sourceTable, windowedTable) {
    var _a;
    var calculation = (_a = definition.schema[name]) === null || _a === void 0 ? void 0 : _a.calculation;
    if (!isTimeShiftCalculation(calculation)) {
        throw new Error("Could not resolve TimeShift calculation with name: ".concat(name));
    }
    var unit = (0, dateUtils_1.momentStringFromDateTrunc)(calculation.granularity);
    var comparison = makeLegacyComparison(calculation);
    var currentRange = (0, dateUtils_1.getDateRange)(windowedTable);
    if (!currentRange || !unit) {
        return windowedTable;
    }
    var timestampAccessor = (0, Accessor_1.accessorForReference)(calculation.source);
    var outputFunc = (0, exports.makeOutputFunc)(definition, name, calculation);
    var comparisonPoints = (0, comparisonEngine_1.generateTimeBasedComparison)(sourceTable, comparison, unit, currentRange, timestampAccessor, outputFunc);
    return (0, comparisonEngine_1.interleaveComparisonPoints)(windowedTable, comparisonPoints, timestampAccessor);
};
exports.timeShiftTransform = timeShiftTransform;
var makeLegacyComparison = function (calculation) {
    var compareTo = calculation.granularity;
    var numberOfPeriods = calculation.numberOfUnits;
    return (0, models_1.makeHistoricalComparisonSpec)(compareTo, '', numberOfPeriods);
};
var makeOutputFunc = function (definition, calcName, calculation) {
    var _a;
    var obj = {};
    if (definition.schema[calcName] !== undefined && calculation.source) {
        obj[calcName] = calculation.source;
    }
    Object.entries(definition.schema).forEach(function (_a) {
        var key = _a[0], columnSchema = _a[1];
        if (columnSchema.calculation && columnSchema.calculation.name === calcName) {
            obj[key] = columnSchema.calculation.source;
        }
    });
    (_a = calculation.copy) === null || _a === void 0 ? void 0 : _a.forEach(function (entry) {
        obj[entry.to.column] = entry.from;
    });
    return mapperFromColumnRefs(obj);
};
exports.makeOutputFunc = makeOutputFunc;
function mapperFromColumnRefs(obj) {
    return function (row) {
        var newRow = {};
        Object.entries(obj).forEach(function (_a) {
            var key = _a[0], value = _a[1];
            newRow[key] = (0, Accessor_1.accessorForReference)(value)(row);
        });
        return newRow;
    };
}
exports.mapperFromColumnRefs = mapperFromColumnRefs;
//# sourceMappingURL=TimeShiftCalculation.js.map